import React from 'react';
import { Link } from 'react-router-dom';

const QUICK_GAMES = [
  ['🟩 Wordle', '/wordle'],
  ['🔗 Connections', '/connections'],
  ['🟩🟩 Dordle', '/dordle'],
  ['🟩🟩🟩🟩 Quordle', '/quordle'],
  ['🎭 Hangman', '/hangman'],
  ['⏱️ Word Scramble', '/word-scramble'],
  ['⛓️ Word Chain', '/word-chain'],
  ['🔤 Word Twist', '/word-twist'],
  ['🧇 Waffle', '/waffle'],
  ['🌸 WordBloom', '/wordbloom'],
  ['🔤 Letter Boxed', '/letter-boxed'],
];

const QUICK_SOLVERS = [
  ['🔀 Jumble Solver', '/jumble'],
  ['🔡 Text Twist Solver', '/text-twist-solver'],
  ['🔍 Unscrambler', '/unscramble'],
  ['🃏 Scrabble Finder', '/scrabble'],
  ['🔠 Wordfeud Helper', '/wordfeud-helper'],
  ['✏️ Crossword Solver', '/crossword'],
  ['💡 Wordle Solver', '/wordle-solver'],
  ['📏 Longest Word', '/longest-word'],
  ['🔢 Syllable Counter', '/syllable-counter'],
  ['📝 Word Counter', '/word-counter'],
  ['🎲 Random Word Generator', '/random-word-generator'],
  ['🔤 Pangram Checker', '/pangram-checker'],
  ['📡 Morse Code', '/morse-code'],
];

export default function Footer() {
  return (
    <footer className="wz-footer">
      <div className="container-xl">
        <div className="row g-4 pb-4" style={{borderBottom:'1px solid rgba(255,255,255,0.1)'}}>

          {/* Brand column */}
          <div className="col-12 col-md-4">
            <div className="wz-footer-brand mb-2">
              <span className="wz-word">Word</span><span className="wz-zingo">Zingo</span>
            </div>
            <p className="wz-footer-desc">
              Your ultimate word game destination. Play free word games and solve
              any word puzzle instantly — 37 games &amp; solvers, always free.
            </p>
            <div className="wz-stats">
              <div className="wz-stat"><strong>37</strong><span>Games</span></div>
              <div className="wz-stat"><strong>190K+</strong><span>Words</span></div>
              <div className="wz-stat"><strong>100%</strong><span>Free</span></div>
            </div>
          </div>

          {/* Games column */}
          <div className="col-6 col-md-2 offset-md-1">
            <div className="wz-footer-heading">🕹 Games</div>
            <ul className="wz-footer-links">
              {QUICK_GAMES.map(([label, path]) => (
                <li key={path}><Link to={path}>{label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Solvers column */}
          <div className="col-6 col-md-2">
            <div className="wz-footer-heading">🔧 Solvers</div>
            <ul className="wz-footer-links">
              {QUICK_SOLVERS.map(([label, path]) => (
                <li key={path}><Link to={path}>{label}</Link></li>
              ))}
            </ul>
          </div>

          {/* About column */}
          <div className="col-12 col-md-3">
            <div className="wz-footer-heading">📌 About</div>
            <p className="wz-footer-about">
              WordZingo is a free word puzzle platform built for word lovers of all ages.
              From classic Hangman to the NYT-style Spelling Bee Solver — we've got it all.
            </p>
            <ul className="wz-footer-links mb-3">
              <li><Link to="/about">📖 About Us</Link></li>
              <li><Link to="/">🎮 All Games</Link></li>
            </ul>
            <div className="wz-domain">
              <i className="bi bi-globe me-1"></i> wordzingo.com
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="wz-footer-bottom">
          <span>© {new Date().getFullYear()} <strong>WordZingo</strong> · wordzingo.com</span>
          <span className="d-none d-sm-inline">·</span>
          <span><Link to="/about">About</Link> · <Link to="/privacy">Privacy Policy</Link> · <Link to="/terms">Terms of Use</Link></span>
          <span className="d-none d-sm-inline">·</span>
          <span>Your daily dose of word fun.</span>

        </div>
      </div>
    </footer>
  );
}
